import { useState } from 'react';
import { Layout } from '@/components/Layout';
import { PropertyCard } from '@/components/Cards';
import { PROPERTIES } from '@/data/index';
import type { PropertyType } from '@/lib/index';

export default function Properties() {
  const [selectedType, setSelectedType] = useState<PropertyType | 'All'>('All');

  const filteredProperties = selectedType === 'All'
    ? PROPERTIES
    : PROPERTIES.filter(property => property.type === selectedType);

  const propertyTypes: Array<PropertyType | 'All'> = ['All', 'Plot', 'Villa', 'Condominium', 'Project'];

  return (
    <Layout>
      <div className="min-h-screen bg-background">
        <section className="relative py-24 bg-primary">
          <div className="absolute inset-0 bg-gradient-to-b from-primary via-primary/95 to-background" />
          <div className="container mx-auto px-4 relative z-10">
            <h1 className="text-5xl md:text-6xl font-serif font-bold text-primary-foreground text-center mb-4">
              Our Properties
            </h1>
            <p className="text-xl text-primary-foreground/80 text-center max-w-2xl mx-auto">
              Discover luxury real estate opportunities in Zanzibar
            </p>
          </div>
        </section>

        <section className="py-12 border-b border-border">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap gap-3 justify-center">
              {propertyTypes.map((type) => (
                <button
                  key={type}
                  onClick={() => setSelectedType(type)}
                  className={
                    selectedType === type
                      ? 'px-6 py-2.5 rounded-full bg-accent text-accent-foreground font-medium transition-all duration-200 shadow-lg'
                      : 'px-6 py-2.5 rounded-full bg-card text-card-foreground border border-border hover:border-accent hover:text-accent font-medium transition-all duration-200'
                  }
                >
                  {type}
                </button>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="mb-8">
              <p className="text-muted-foreground text-center">
                {filteredProperties.length} {filteredProperties.length === 1 ? 'property' : 'properties'} found
              </p>
            </div>

            {filteredProperties.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredProperties.map((property) => (
                  <PropertyCard key={property.id} property={property} />
                ))}
              </div>
            ) : (
              <div className="text-center py-24">
                <div className="max-w-md mx-auto">
                  <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-muted flex items-center justify-center">
                    <svg
                      className="w-12 h-12 text-muted-foreground"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                      />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-semibold mb-2">No Properties Found</h3>
                  <p className="text-muted-foreground mb-6">
                    No properties match your current filter. Try selecting a different type.
                  </p>
                  <button
                    onClick={() => setSelectedType('All')}
                    className="px-6 py-3 bg-accent text-accent-foreground rounded-lg font-medium hover:bg-accent/90 transition-colors"
                  >
                    View All Properties
                  </button>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    </Layout>
  );
}